import { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, Button, DialogTitle, DialogActions, DialogContent } from '@mui/material';
import { AwaitButton } from '../../../../reusable-components/await-button';

FacilityAccountConfirmDialog.propTypes = {
  title: PropTypes.string,
  action: PropTypes.func,
  cancelAction: PropTypes.func,
  content: PropTypes.string,
  actionButtonText: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  buttonVariant: PropTypes.string,
};

export default function FacilityAccountConfirmDialog({
  buttonVariant,
  title = 'Delete',
  content,
  action,
  cancelAction = () => null,
  color = 'error',
  actionButtonText = 'Delete',
  disabled = false,
  ...other
}) {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);

  const handleOpenConfirm = (e) => {
    e.preventDefault();
    e.confirmDialog = true;
    setIsConfirmOpen(true);
    e.stopPropagation();
  };

  const handleCloseConfirm = () => {
    cancelAction();
    setIsConfirmOpen(false);
  };
  const handleAction = () => {
    action();
    setIsConfirmOpen(false);
  };

  return (
    <>
      {buttonVariant && (
        <Button
          variant={buttonVariant}
          size="small"
          color={color}
          onClick={handleOpenConfirm}
          disabled={disabled}
          {...other}
        >
          {actionButtonText}
        </Button>
      )}
      <Dialog fullWidth maxWidth="xs" open={isConfirmOpen} onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
        handleCloseConfirm();
      }} {...other}>
        <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>

        {content && <DialogContent sx={{ typography: 'body2' }}> {content} </DialogContent>}

        <DialogActions>
          <AwaitButton variant="contained" color={'primary'} onClick={handleAction}>
            {actionButtonText === 'On Hold' ? 'Confirm' : actionButtonText}
          </AwaitButton>

          <Button variant="outlined" color="inherit" onClick={handleCloseConfirm}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
